<template>
  <div id="train">
    <div class="course-list">
      <p class="nav" @click="toSceneList"><span class="el-icon-arrow-left"></span><span>返回</span></p>
    </div>

      

  </div>


</template>

<script>
export default {
  data() {
    return {
      id: this.$route.query.id, //场景id
      type: this.$route.query.type, //上级tab类型
      tabMajorId: this.$route.query.tabMajorId, //tab的id
      tjkId: null,
      trainId: null,
      showEachDialog:false,//对练弹窗
      recordState:'', //外呼能力考核
      notification:false,//点击继续练习弹窗
      exercisePopup:false, //点击点击考核弹窗
      ismajorId:'',//保存结束考核状态
      istype:'',//保存结束考核状态
      exercisePopupNum:0,//对练是否结束状态（点击考核）

        step: 'second',
        input: '',
        dialogVisible: false,
        partner: {},
        clickStatus :{
          recordId : null,
          clickStatus : "Yes",
          showContinue : null //用于首次 点击练习后，点停止，在不刷新界面的情况下改变按钮显隐
        }
    }
  },
  
  mounted() {
       if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        location.reload();
    }
  
    //页面加载就判断是否有 “结束对练” 可以点
    this.isHasPri();
    localStorage.setItem('id',this.$route.query.id)
    localStorage.setItem('tabMajorId',this.$route.query.tabMajorId)

  },
  methods: {
    //点击考核弹窗确定
    exerciseClickconfirm(){
      // console.log(this.istype,this.id,this.ismajorId,'数据')
      this.stopPrict()
      if(this.istype == 'BusinessKnowledgeStudy' || this.istype == 'VoiceGraduate') {
        //业务知识学习，结业课
        this.$router.push({path: '/train/childCourseList', query: {id: this.id, type: this.istype, tabMajorId: this.tabMajorId, majorId: this.ismajorId}});
      }else if(this.istype == 'PartnerCallOutExercise') {
        //对练
        this.$router.push({path: '/train/partnerIndex', query: {id: this.id, type: this.istype, tabMajorId: this.tabMajorId}});
      }else if(this.istype == 'MankindDemoStudy') {
        //真人示范学习
        this.$router.push({path: '/train/recordDetail', query: {id: this.id, type: this.istype, tabMajorId: this.tabMajorId, majorId: this.ismajorId}});
      }else if(this.istype == 'CallOutAbilityCheck') {
        //考核
        this.toKaoheDetail(this.ismajorId);
        //  this.$router.go(0)
      }else {

      }
      this.exercisePopup=false
     
    },
    // 继续练习弹窗点击确定
    Clickconfirm(){
      
      this.notification=false
      this.showEachDialog = true;
      this.stopKaohePrict()
  
    },
    //刷新
    Refresh() {
            if (location.href.indexOf("#reloaded") == -1) {
                location.href = location.href + "#reloaded";
                location.reload();
            }
        },

    //返回场景
    toSceneList() {
      this.$router.push({path: '/train/index', query: {type: this.type, tabMajorId: this.tabMajorId}});
    },
    goDuilian(recordId, type){
       


        if(recordId){
            this.clickStatus.recordId = recordId
             this.showEachDialog = true;
           
        }
        var available = this.checkOperationAvailable(type);
        if(available == 'needEndKaohe'){
            // this.$message({
            //     message: '需要先结束考核',
            //     type: 'error'
            // });
            // return;
         this.notification=true
        }else{this.showEachDialog = true;}
    },
    stopKaohePrict() {
        var self = this;
      this.$http.get(API_ROOT.college + `/voiceExerciseCustomer/endExamExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
          if(result.data.success) {
              self.queryMajorAll();
          }
      });
    },
    toKaoheDetail(id) {
      // console.log(id,'有没有')
      this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/examReady', {'id':id}).then(response=>{
        var result = response.data;
        if(result.success) {
          this.toSign(id);
        }else {
          console.log(result.msg)
    
        
          // this.$alert("你考核未合格，请重新报名参加培训");
          
        }
      },response => {
        this.$alert('AJAX访问接口异常！');
      })
    },
    toSign(id) {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id='+id).then(response=> {
        var result = response.data;
        if(result.success) {
          
        }
      },response=> {
        
      })
    },

      //============
      //查询淘金客信息
      getCustomerUser() {
          this.$http.get('/customer/action/currentUser/customerUser').then(response=>{
              var result = response.data;
              if(result.success) {
                  this.tjkId = result.data.id;
                  this.isHasPri();
              }else{
                  this.$alert(result.msg);
              }
          },response => {
              this.$alert('AJAX访问接口异常！');
          })
      },
      showKnow() {
          this.step = 'second';
      },
      isHasPri() {
          this.$http.get(API_ROOT.college + `/voice/exercise/existExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
              if(result.data.success && result.data.data) {
                  this.step = 'handing';
              }else {
                  this.step = 'second';
                  //展示开始对练还是继续对练
              }
          });
      },
      goToPrict() {
          var patrn = /^(-)?\d+(\.\d+)?$/;
          if(!patrn.exec(this.input)) {
              this.$message({
                  message: '请输入正确的淘金号',
                  type: 'error'
              });
              return;
          }
          if(this.input && this.input.length < 9) {
              this.$message({
                  message: '淘金号长度至少为9位',
                  type: 'error'
              });
              return;
          }


          //查询是否存在当前淘金号
          this.$http.get(API_ROOT.tjkuser + `/tjk/queryTjkList?tjkParam=${this.input}&returnAllData=1`).then((result) => {
              if(result.data.data.length) {
                  this.partner = result.data.data[0];
                  this.dialogVisible = true;
              }else {
                  this.$message({
                      message: '未找到对应的对练伙伴，请重新输入淘金号',
                      type: 'error'
                  });
              }
          });
          // 打开打卡，然后展示正在练习
      },
      updateSlickStatus(){
            var self = this;
          this.$http.post(API_ROOT.college + '/majorAll/majorAllTjkUpdate', this.clickStatus).then(response=>{
              var result = response.data;
              if(result.success) {
                  self.queryMajorAll();
              }else {
                  this.$alert(result.msg);
              }
          },response => {
              this.$alert('majorAllTjkUpdate AJAX访问接口异常！');
          })
      },
      stopPrict() {
          this.$http.get(API_ROOT.college + `/voice/exercise/endExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
              if(result.data.success) {
                  this.step = 'second';
              }
          });
          this.clickStatus.showContinue = 'Yes';
      },
      newPrict() {
          this.step = 'second';
      },
      //清空排版数据
      clearSchedule() {
          this.$http.get('http://127.0.0.1:26688/api/SignIn/clearScheduleCache').then((res) => {})
          this.sureGoToPri();
          this.updateSlickStatus();
      },
      checkOperationAvailable(ope){
        //如果点击的是考核，看当前是否是 “结束对练”按钮能点
        if(ope == 'CallOutAbilityCheck'){
            if(this.step == 'handing'){
                return 'needEndDuilian';
            }
        }
      },
      sureGoToPri() {
          this.$http.get(API_ROOT.college + `/voice/exercise/ready?tjkId=${this.partner.id}&assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
              if(result.data.success) {
                  this.getHawkeye();
                  this.input = '';
                  this.step = 'handing';
                  this.dialogVisible = false;
                  this.showEachDialog = false;
              }else {
                  if(result.data.msg && result.data.msg.indexOf('不能有多个语音订单排班') > -1){
                      this.$message({
                          message: '请先结束对练 或者结束考核',
                          type: 'error'
                      });
                  }else{
                      this.$message({
                          message: result.data.msg,
                          type: 'error'
                      });
                  }
              }
          });
      },
      //调用小助手
      getHawkeye() {
          this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(response=> {
              var result = response.data;
              if(result.success) {

              }
          },response=> {

          })
      },
      handleClose(done) {
          this.$confirm('确认关闭？').then(res => {
              done();
          }).catch(res => {});
      }


  }
}
</script>

<style lang="less" scoped>
#train {
  background: #f5f6f7;
  height: 100%;
}
</style>

<style lang="less" scoped>
    .priContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        .prictice {
            .pricComfir {
                width: 100%;
                margin-top: 20px;
                padding-bottom:50px;
            }
            .comTitle {
                font-weight: 700;
                margin-bottom: 15px;
            }
            .content {
                display: flex;
            }
            .input {
                .el-input__inner {
                    border-radius: 10px;
                    width: 320px;
                }
            }
            .comfirmBtn {
                margin-left: 15px;
                width: 170px;
                line-height: 40px;
                background-color: #D3D3D3;
                text-align: center;
                color: #fff;
                border-radius: 15px;
            }
            .ActiveComBtn {
                background-color: #118EF2;
                cursor: pointer;
            }
            .stOrNew {
                width: 100%;
                display: flex;
                justify-content: space-between;
            }
            .defaultBtn {
                width: 120px;
                color: #fff;
                border-radius: 20px;
                text-align: center;
                line-height: 35px;
                height: 35px;
                cursor: pointer;
            }
            .newPrict {
                background-color: #008000;
                margin-left: 20px;
            }
            .stopPrict {
                background-color: #FF0000;
            }
            .handBox {
                margin-top: 50px;
            }
        }
    }
    .titleposition{display: flex;justify-content: left;}
    .textposition{margin-left: 10px;font-weight: 600; font-size: 16px;}
    .isgreen{color: #39CA54;}
    .isred{color: #FF0000;}
    .status_style{background: #FF0000 !important;}
    /deep/.el-dialog{border-radius: 11px;}
    .isbox{text-align: center;}
</style>


// WEBPACK FOOTER //
// ./src/page/train/courseList.vue